import { service, openApi } from '@/utils/request'

export default {
  login (payload) {
    return service.post('/Login/LoginByTel', payload)
  },
  pcLogin (payload) {
    return service.post('/Login/LoginByToken', payload)
  },
  checkIsRegistered (phone) {
    return service.get(process.env.VUE_APP_RCCL + '/api/Orchard.Rccl.Users/LoginApi/IsRegistered', {
      params: {
        phone
      }
    })
  },
  checkIsMember (phone) {
    return service.get(process.env.VUE_APP_RCCL + '/Rccl.OpenApi/User/IsRegisteredMember', {
      params: {
        phone
      }
    })
  },
  checkHasRegister (telephone, callingCode) {
    return openApi.post(process.env.VUE_APP_RCCL + '/Rccl.OpenApi/User/CheckHasRegister', {
        telephone, callingCode
    })
  },
  bindBooking (payload) {
    return service.post('/Booking/BindBooking', payload)
  },
  bindOut (payload) {
    return service.post('/Booking/BindOut', payload)
  },
  getBookingInfo (isGetMajorGuests = false) {
    return service.get('/Booking/GetBookingAndCruiseInfo',
    {
      params: {isGetMajorGuests}
    })
  },
  getIndex (shipCode) {
    return service.get('/Home/GetAll?v=' + (new Date()).getTime(), {
      params: { shipCode }
    })
  },
  getProductListByCategory (categoryName, shipCode) {
    return service.get('/Product/GetProductListByCategory', {
      params: { categoryName, shipCode }
    })
  },
  getProductDetail (productId) {
    return service.get('/Product/Detail', {
      params: { productId }
    })
  },
   getProductDetailV2 (productId) {
    return service.get('/product/detailv2', {
      params: { productId }
    })
  },
  getProductShorex (cityName) {
    return service.get('/Product/PcpShorex', {
      params: { cityName }
    })
  },
  getShoppingCartsList () {
    return service.get('/ShoppingCart/NewShoppingCarts')
  },
  getSmShoppingCartsList () {
    return service.get(process.env.VUE_APP_SMAPI + '/SMAPIShoppingCart/Cart')
  },
  getPackageProducts (payload) {
    return service.get('/ProductInv/GetPackageProductsInvs', {
      params: payload
    })
  },
  getCanSelectGuestsByProduct (payload) {
    return service.post('/Order/GetCanSelectGuestsByProduct', payload)
  },
  addProduct (payload) {
    return service.post('/Order/AddProduct', payload)
  },
  editProduct (payload) {
    return service.post('/Order/EditProduct', payload)
  },
  getHotSearch () {
    return service.get('/Search/GetHotSearchKeywords')
  },
  searchProductByName (payload) {
    return service.get('/Search/SearchByName', {
      params: payload
    })
  },
  deleteProduct (payload) {
    return service.post('/Order/deleteProduct', payload)
  },
  getQuestion () {
    return service.get('/FAQ/GetPCPFAQ')
  },
  submitOrder (payload) {
    return service.post('/Order/SubmitOrder', payload)
  },
  getOrderDetail (payload) {
    return service.post('/OrderDetail/CheckOutV2', payload)
  },
  getOriginOrderDetail () {
    return service.get('/OrderDetail/OriginOrder')
  },
  getPictureCode () {
    return service.get('/Util/PictureVerificationCode')
  },
  getMsgVerifyCode (payload) {
    return service.post('/Sms/GetVerifyCode', payload)
  },
  checkOrderStatus () {
    return service.get('/Order/CheckStatus')
  },
  editOrder () {
    return service.post('/Order/EditOrder')
  },
  getPopupMessage () {
    return service.post('/Message/GetPopupMessage', { type: 2 })
  },
  getCombos (payload) {
    return service.get('/Combo/GetCombos', {
      params: payload
    })
  },
  getBookingOrderInfo (payload) {
    return service.get('/Booking/GetBookingAndOrderInfo', {
      params: payload
    })
  },
  getNewsList (payload) {
    return service.get('/News/GetAllNews', {
      params: payload
    })
  },
  getNewsDetail (payload) {
    return service.get('/News/GetNewsDetail', {
      params: payload
    })
  },
  getQrCode (payload) {
    return service.get('/Message/GetQrCode', {
      params: payload
    })
  },
  getUrlToShoppingMall (page) {
    return service.get('/RedirectToSM/RedirectToShoppingMall', {
      params: { page }
    })
  },
  // 允许下单的乘客（全舱预定）
  getCanBookingGuests (data) {
    return service.post('/Booking/GetCanBookingGuests', data)
  },
  // 查询未出行订单
  getBookingsByBookingOrderId (payload) {
    return service.post('/Booking/GetBookingsByBookingOrderId', payload)
  },
  loginAndBindingFromBookingMiniApp (payload) {
    return service.post('/Booking/LoginAndBindingFromBookingMiniApp', payload)
  },
  getSMOrderState () {
    return service.get(process.env.VUE_APP_SMAPI + '/SMAPIOrder/GetOrderState')
  },
  getCallingCode () {
    return service.post('/Util/GetCallingCodes')
  },
  //检查隐私版本是否是最新的
  getUserVersionIsEffective (userName) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/User/GetUserVersionIsEffective", { userName })
  },
  //同意隐私协议
  agreePrivacyPolicy (userName) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/User/AgreePrivacyPolicy", { userName })
  },
  // 获得是否同意过最终的隐私政策-202508
  getUserAgreeVersionIsEffective(userName) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/User/GetUserAgreeVersionIsEffective", { userName })
  },
  // 确认同意最终的隐私政策-202508
  agreeToTheLastAgreement(requestData) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/User/AgreeToTheLastAgreement", requestData)
  },
  // 获取用户是否开启隐私保护
  changePrivacyProtectionIsOpen (userName) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/UserCenter/ChangePrivacyProtectionIsOpen", { userName })
  },
  // 更新用户是否开启隐私保护
  updateUserPrivacyProtection (requestData) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/UserCenter/UpdateUserPrivacyProtectionV1", requestData)
  },
  // 取消订单（常规游）
  cancelOrderWithOnlyFreeShorex() {
    return service.post("/Order/CancelOrderWithOnlyFreeShorex")
  },
  // 获取赠品列表
  getProductGiftList(requestData) {
    return service.post(process.env.VUE_APP_RCCL+"/Rccl.PCP/ProductInv/GetProductInvHasProductGift", requestData)
  },
  // 根据选中的日期获取时间段
  getProductGiftTimeSlotList(requestData) {
    return service.post(process.env.VUE_APP_RCCL+"/Rccl.PCP/ProductInv/GetProductInvs", requestData)
  },
  // 获取可选择赠品的乘客列表
  getCanSelectGuestsByProductGift(requestData) {
    return service.get(process.env.VUE_APP_RCCL+"/Rccl.PCP/GetGuestsByProduct/GetCanSelectGuestsByProduct", {
      params: { ...requestData }
    })
  },
  // 全部订单
  getAllOrder() {
    return service.get('/OrderDetail/AllOrder')
  },
  // 取消子订单
  cancelSubOrder(requestData) {
    return service.post('/Order/CancelSubOrder', requestData)
  },
  // 购物车选中
  getSelectedShoppingCarts(requestData) {
    return service.post('/ShoppingCart/GetSelectedShoppingCarts', requestData)
  },
  // 购物车反选
  cancelSelectedShoppingCarts(requestData) {
    return service.post('/ShoppingCart/CancelSelectedShoppingCarts', requestData)
  },
  // 提交购物车检查促销是否可用
  validatePromoInfoBeforeSubmitShoppingCart(requestData) {
    return service.post('/ShoppingCart/ValidatePromoInfoBeforeSubmitShoppingCart', requestData)
  },


  // 已登记
   submitOutOfStock (payload) {
    return service.post('/OutOfStock/SubmitOutOfStock', payload)
  },
  // 购物车数量
  getShoppingCartCount() {
    return service.get('/ShoppingCart/GetShoppingCartCount')
  },
  // 可用的优惠券数量
  getGetAvailableCouponCount() {
    return service.post('/Coupon/GetAvailableCouponCount')
  },
  /**
   * 根据产品获取适用促销/优惠券
   * @param requestData {productId, qty}
   */
  getBestDiscountByProduct(requestData) {
    return service.post('/Coupon/GetBestDiscountByProduct', requestData)
  },
  /**
   * 根据产品获取可用的优惠券列表
   * @param requestData {productId}
   */
  getCouponListByProduct(requestData) {
    return service.post('/Coupon/GetCouponListByProduct', requestData)
  },
  /**
   * 购物车更换优惠券
   * @param requestData {shoppingCartIds, couponId}
   */
  changeCoupon(requestData) {
    return service.post('/ShoppingCart/ChangeCoupon', requestData)
  },
  /**
   * 新产品列表(产品列表、搜索)
   * 大分类名称、游轮code、搜索关键词、组合Id
   * @param requestData {categoryName, shipCode, keyword, comboId}
   */
  getProductList(requestData) {
    return service.post('/Product/GetProductList', requestData)
  },
  /**
   * 获取通用信息
   */
  getCommonInfo() {
    return service.post('/home/getCommonInfo')
  },
  /**
   * 获取通用信息
   */
  getGetObcInfo() {
    return service.post('/Booking/GetObcInfo')
  }
}
